<template>
  <!-- 按钮二次封装
      @author: liuguisheng
      @date: 2019-9-13
  -->
  <div v-if="isDisplay"
       class="form-item_input preview-item_button"
       :style="{'padding-left': paddingLeft}">
    <el-button @click="onClick"
               :type="buttonType"
               :plain="!buttonBack"
               :size="buttonSize"
               :loading="loading">
      <span style="display: inline-block" :style="{minWidth: width }">
        {{buttonText}}
      </span>
    </el-button>
  </div>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
  data () {
    return {
      // loading效果页面绑定
      loading: false
    }
  },
  mounted () {
    setTimeout(_ => {
      this.formBaseOptionConfig.clicked && this.onClick()
    }, 500)
  },
  methods: {
    /**
     * @name 按钮loading效果设置
     * @description 根据设置的是否加loading效果和设置的节流时间判断页面绑定的loading
     * @returns { void }
     * @author liuguisheng
     * @version 2019-9-21
     * 
    */
    onClick () {
      // 点击过的按钮取消初始状态(-1), 复制为undefined
      this.currentModel = undefined;
      // 提取变量
      let { buttonLoading,buttonThrottle } = this;
      // 定义基础时间和最终加载的时间
      let newTime = 0;
      // 调用数组过滤的方法并取出需要加载的loading时间
      newTime = this.filterArr(buttonLoading, Boolean(buttonThrottle), buttonThrottle)[0].time;
      // 调用加载
      this.loadingTime(newTime);
      // ### 触发事件
      this.emitEvent("change");
      
      // 记录点击状态
        // 获取响应者
      const {emit = [], } = this.formEventConfig;

      const eventId = emit[0];
      if ( !eventId ) return;
      const { on } = this.eventMap[eventId];
      const { action , form } = on;
      // 找到跟这个相应者相关的类型为button的触发者, 将他们的clicked全部设置为false
      // 遍历eventMap
      Object.keys(this.eventMap).forEach( key => {
        // 获取event配置
        const config = this.eventMap[key];
        // 找到相应及触发
        const { on, emit } = config;

        // 如果响应者与当前按钮绑定的响应者相同
        if ( on.form === form) {
          // 则把这个事件中的button触发者的clicked标识设为false
          emit.forEach(({form}) => {
            const item = this.formMap[form];
            const { baseOption, node } = item;
            if (node.type === 'button' && baseOption.clicked) {
              baseOption.clicked = false;
            }
          })
        }
      })
      // 更新当前的按钮的clicked为true;
      this.formBaseOptionConfig.clicked = true;
    },
    /**
     * @name 过滤方法
     * @description 根据用户选择是否加loading效果和节流时间判断按钮的loading时间
     * @param { Boolean } loading 用户选择的是否加loading效果
     * @param { Boolean } throttle 用户选择的节流时间（转成的boolean）
     * @param { Number } chooseThrottle 用户选择的节流时间
     * @returns { void } 
     * @author liuguisheng
     * @version 2019-9-24
    */
    filterArr ( loading, throttle, chooseThrottle ) {
      // 定义条件和结果数组
      let actions =  new Set([
        {loading: true,throttle: true,time:chooseThrottle},
        {loading: false,throttle: true,time:chooseThrottle},
        {loading: true,throttle: false,time:300},
        {loading: false,throttle: false,time:0}
      ])
      let arr = [...actions];
      // 过滤出符合条件的那一项
      return arr.filter(el => {
        return el.loading == loading && el.throttle == throttle
      })
    },
    /**
     * @name loading时间加载
     * @param { Number } time 定时时间
     * @returns { void }
     * @author liuguisheng
     * @version 2019-9-21
     * 
    */
    loadingTime ( time ) {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, time)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemButton.vue